// extracted by mini-css-extract-plugin
module.exports = {"panel":"panelcontainer_panel__3kRUA","title":"panelcontainer_title__g2S8s","content":"panelcontainer_content__1gQDl"};